const SCHEMA: string = process.env.REACT_APP_MASTER_MAIN_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MASTER_MAIN_ENTITY || '';
const LIST_ANTICIPO: string = `/${process.env.REACT_APP_ROUTE_PATH_MAIN}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA_RENDIDOR_SOLICITUD_ANTICIPO}`;
const CDPAIS_COLOMBIA: string = '480';

export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
    LIST_ANTICIPO,
    CDPAIS_COLOMBIA
};